/* DDD storefront 2026 — interactions. Vanilla, no dependencies.
   Header, mega menus, drawers, predictive search, AJAX cart, sharing,
   rails, card tilt, scroll reveals, toasts. Exposes window.DD for pages. */
(function () {
  "use strict";
  var doc = document, html = doc.documentElement;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  var clean = function (t) { return String(t || "").replace(/\s*\(DDD\d+\)\s*$/i, ""); };
  var icon = function (name) { var t = doc.getElementById("dd-ico-" + name); return t ? t.innerHTML : ""; };

  /* ---------- money ---------- */
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP";
    try { return new Intl.NumberFormat(undefined, { style: "currency", currency: cur }).format(cents / 100); }
    catch (e) { return "£" + (cents / 100).toFixed(2); }
  }

  /* ---------- toast ---------- */
  var toastHost;
  function toast(msg, err) {
    if (!toastHost) { toastHost = doc.createElement("div"); toastHost.className = "dd-toasts"; toastHost.setAttribute("aria-live", "polite"); doc.body.appendChild(toastHost); }
    var t = doc.createElement("div");
    t.className = "dd-toast" + (err ? " dd-toast--err" : "");
    t.innerHTML = (err ? "" : icon("check")) + "<span>" + esc(msg) + "</span>";
    toastHost.appendChild(t);
    setTimeout(function () { t.classList.add("is-out"); setTimeout(function () { t.remove(); }, 320); }, 2600);
  }

  /* ---------- lazy images for hidden panels ---------- */
  function wake(root) { $$("img[data-dd-src]", root).forEach(function (im) { im.src = im.getAttribute("data-dd-src"); im.removeAttribute("data-dd-src"); }); }

  /* ---------- scroll lock + drawers ---------- */
  var openLayers = 0, lastFocus = null;
  function lock(on) { openLayers = Math.max(0, openLayers + (on ? 1 : -1)); doc.body.style.overflow = openLayers ? "hidden" : ""; }
  function openDrawer(name) {
    var d = $('[data-dd-drawer="' + name + '"]'); if (!d || d.classList.contains("is-open")) return d;
    closeMegas();
    lastFocus = doc.activeElement;
    d.classList.add("is-open"); d.setAttribute("aria-hidden", "false"); lock(true); wake(d);
    var f = $("button, a, input", $(".dd-drawer__panel", d)); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
    return d;
  }
  function closeDrawer(d) {
    if (!d || !d.classList.contains("is-open")) return;
    d.classList.remove("is-open"); d.setAttribute("aria-hidden", "true"); lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- header ---------- */
  function initHeader() {
    var header = $("[data-dd-header]"); if (!header) return;
    var onScroll = function () { header.classList.toggle("is-scrolled", window.scrollY > 8); };
    onScroll(); window.addEventListener("scroll", onScroll, { passive: true });

    var tb = $("[data-dd-topbar]");
    // Departure-board ticker: each digit is a strip of 0-9 three times over; it spins
    // through two full turns and settles on its number, slowly, left to right. Exact
    // landing because each step is a fixed fraction of the strip, not a line of text.
    $$("[data-dd-odo]").forEach(function (o) {
      var txt = o.getAttribute("data-dd-odo"), k = 0, strip = "";
      for (var c = 0; c < 3; c++) for (var d = 0; d < 10; d++) strip += "<i>" + d + "</i>";
      o.setAttribute("aria-label", txt);
      o.innerHTML = txt.split("").map(function (ch) {
        if (!/\d/.test(ch)) return '<span class="dd-odo__c" aria-hidden="true">' + esc(ch) + "</span>";
        return '<span class="dd-odo__d" aria-hidden="true" style="--t:' + (20 + +ch) + ";--k:" + (k++) + '"><span class="dd-odo__s">' + strip + "</span></span>";
      }).join("");
    });
    var odoGo = function (root, on) { $$(".dd-odo", root).forEach(function (o) { o.classList.toggle("is-go", on); }); };
    // Hero count: roll once when it comes into view
    $$(".dd-navcount .dd-odo").forEach(function (o) {
      requestAnimationFrame(function () { setTimeout(function () { o.classList.add("is-go"); }, 300); });
    });
    if (tb) {
      var msgs = $$(".dd-topbar__msg", tb), i = 0;
      var hold = function (m) { return $(".dd-odo", m) ? 11000 : 4200; };
      if (msgs[0]) setTimeout(function () { odoGo(msgs[0], true); }, 500);
      var step = function () {
        var cur = msgs[i]; i = (i + 1) % msgs.length; var nxt = msgs[i];
        cur.classList.remove("is-on"); cur.classList.add("is-off");
        nxt.classList.remove("is-off"); nxt.classList.add("is-on");
        setTimeout(function () { cur.classList.remove("is-off"); odoGo(cur, false); }, 650);
        setTimeout(function () { odoGo(nxt, true); }, 350);
        setTimeout(step, hold(nxt));
      };
      if (msgs.length > 1 && !reduce) setTimeout(step, hold(msgs[0]));
    }
  }

  /* ---------- mega menus (hover intent + click + keyboard) ---------- */
  var scrim;
  function closeMegas(except) {
    $$("[data-dd-mega].is-open").forEach(function (m) { if (m !== except) { m.classList.remove("is-open"); var b = $("button", m); if (b) b.setAttribute("aria-expanded", "false"); } });
    if (scrim && !except) scrim.classList.remove("is-on");
  }
  function initMegas() {
    scrim = $("[data-dd-mega-scrim]");
    $$("[data-dd-mega]").forEach(function (item) {
      var btn = $("button", item), tOpen, tClose;
      var open = function () { clearTimeout(tClose); closeMegas(item); item.classList.add("is-open"); btn.setAttribute("aria-expanded", "true"); wake(item); if (scrim) scrim.classList.add("is-on"); };
      var close = function () { item.classList.remove("is-open"); btn.setAttribute("aria-expanded", "false"); if (!$("[data-dd-mega].is-open") && scrim) scrim.classList.remove("is-on"); };
      if (finePointer) {
        item.addEventListener("mouseenter", function () { clearTimeout(tClose); tOpen = setTimeout(open, 90); });
        item.addEventListener("mouseleave", function () { clearTimeout(tOpen); tClose = setTimeout(close, 160); });
      }
      btn.addEventListener("click", function () { item.classList.contains("is-open") ? close() : open(); });
      item.addEventListener("keydown", function (e) { if (e.key === "Escape") { close(); btn.focus(); } });
    });
    if (scrim) scrim.addEventListener("click", function () { closeMegas(); });
    doc.addEventListener("click", function (e) { if (!e.target.closest("[data-dd-mega]")) closeMegas(); });
  }

  /* ---------- predictive search ---------- */
  var S = {};
  function useInput(inp) { S.input = inp; S.root.classList.toggle("is-drop", inp === S.hInput); }
  function placeDrop() {
    if (!S.hInput) return;
    var r = S.hForm.getBoundingClientRect();
    S.root.style.setProperty("--drop-top", Math.round(r.bottom + 10) + "px");
    S.root.style.setProperty("--drop-right", Math.max(12, Math.round(window.innerWidth - r.right)) + "px");
  }
  function openDrop() {
    if (!S.root) return;
    closeMegas(); useInput(S.hInput); placeDrop();
    S.root.classList.add("is-open");
    if (S.hInput.value.trim().length >= 2) runSearch(); else { S.results.hidden = true; S.idle.hidden = false; }
  }
  function openSearch(prefill) {
    if (!S.root) return;
    // desktop: just focus the header box (results drop down under it)
    if (S.hInput && S.hInput.offsetParent !== null && prefill == null) { S.hInput.focus(); S.hInput.select(); return; }
    useInput(S.oInput);
    closeMegas();
    if (!S.root.classList.contains("is-open")) { S.root.classList.add("is-open"); lock(true); }
    if (prefill != null) { S.input.value = prefill; runSearch(); }
    setTimeout(function () { S.input.focus(); S.input.select(); }, 40);
  }
  function closeSearch() {
    if (!S.root || !S.root.classList.contains("is-open")) return;
    var wasDrop = S.root.classList.contains("is-drop");
    S.root.classList.remove("is-open");
    if (!wasDrop) lock(false); else if (S.hInput) S.hInput.blur();
  }
  var sTimer, sCtrl;
  function runSearch() {
    var q = S.input.value.trim();
    clearTimeout(sTimer);
    if (q.length < 2) { S.results.hidden = true; S.idle.hidden = false; return; }
    S.idle.hidden = true; S.results.hidden = false;
    S.results.innerHTML = '<div class="dd-search__skeleton"><i></i><i></i><i></i><i></i></div>';
    sTimer = setTimeout(function () {
      if (sCtrl) sCtrl.abort();
      sCtrl = window.AbortController ? new AbortController() : null;
      var url = (window.routes && routes.predictive_search_url || "/search/suggest") + ".json?q=" + encodeURIComponent(q) +
        "&resources[type]=product,collection,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last";
      fetch(url, { signal: sCtrl ? sCtrl.signal : undefined, headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (d) { renderSearch(q, (d.resources && d.resources.results) || {}); })
        .catch(function (e) { if (e.name !== "AbortError") S.results.innerHTML = '<p class="dd-search__empty">Search is having a moment. Press Enter to search anyway.</p>'; });
    }, 160);
  }
  function typeFromTitle(t) { t = (t || "").toLowerCase(); return t.indexOf("clipart") > -1 ? "Clipart" : t.indexOf("fussy") > -1 ? "Fussy-Cut Pages" : t.indexOf("paper") > -1 ? "Digital Papers" : ""; }
  function renderSearch(q, r) {
    var prods = r.products || [], cols = r.collections || [], qs = r.queries || [];
    var all = "/search?type=product&q=" + encodeURIComponent(q);
    if (!prods.length && !cols.length) {
      S.results.innerHTML = '<p class="dd-search__empty">Nothing matches “' + esc(q) + '” yet. Try a broader word, like “floral” or “christmas”.</p>';
      return;
    }
    var h = '<div class="dd-search__cols"><div>';
    if (prods.length) {
      h += '<div class="dd-search__label">Designs</div><div class="dd-search__products">';
      prods.slice(0, 8).forEach(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || "";
        if (img) img += (img.indexOf("?") > -1 ? "&" : "?") + "width=300";
        h += '<a class="dd-sresult" data-dd-sitem href="' + esc(p.url) + '"><div class="dd-sresult__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "") +
          '</div><div class="dd-sresult__t">' + esc(clean(p.title)) + '</div><div class="dd-sresult__p">' + typeFromTitle(p.title) + "</div></a>";
      });
      h += "</div>";
    }
    h += '</div><div class="dd-search__side">';
    if (qs.length) { h += '<div class="dd-search__label">Suggestions</div>'; qs.slice(0, 5).forEach(function (x) { h += '<a data-dd-sitem href="' + esc(x.url) + '">' + (x.styled_text || esc(x.text)) + "</a>"; }); }
    if (cols.length) { h += '<div class="dd-search__label" style="margin-top:16px">Themes</div>'; cols.slice(0, 6).forEach(function (c) { h += '<a data-dd-sitem href="' + esc(c.url) + '">' + esc(c.title) + "</a>"; }); }
    h += "</div></div>";
    h += '<div class="dd-search__all"><a class="dd-btn dd-btn--ghost dd-btn--block" data-dd-sitem href="' + all + '">See every result for “' + esc(q) + "”</a></div>";
    S.results.innerHTML = h;
    S.active = -1;
  }
  function moveActive(dir) {
    var items = $$("[data-dd-sitem]", S.results); if (!items.length) return;
    S.active = (S.active + dir + items.length) % items.length;
    items.forEach(function (it, i) { it.classList.toggle("is-active", i === S.active); });
    items[S.active].scrollIntoView({ block: "nearest" });
  }
  function initSearch() {
    S.root = $("[data-dd-search]"); if (!S.root) return;
    S.oInput = $("[data-dd-search-input]", S.root); S.idle = $("[data-dd-search-idle]", S.root); S.results = $("[data-dd-search-results]", S.root); S.active = -1;
    S.hForm = $("[data-dd-hsearch]"); S.hInput = S.hForm ? $("[data-dd-hsearch-input]", S.hForm) : null;
    S.input = S.oInput;
    var keys = function (e) {
      if (e.key === "ArrowDown") { e.preventDefault(); moveActive(1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); moveActive(-1); }
      else if (e.key === "Enter" && S.active > -1) { var it = $$("[data-dd-sitem]", S.results)[S.active]; if (it) { e.preventDefault(); location.href = it.href; } }
      else if (e.key === "Escape") { closeSearch(); }
    };
    S.oInput.addEventListener("input", function () { useInput(S.oInput); runSearch(); });
    S.oInput.addEventListener("keydown", keys);
    if (S.hInput) {
      S.hInput.addEventListener("focus", openDrop);
      S.hInput.addEventListener("input", function () { if (!S.root.classList.contains("is-open")) openDrop(); useInput(S.hInput); runSearch(); });
      S.hInput.addEventListener("keydown", keys);
      window.addEventListener("resize", placeDrop, { passive: true });
      // the header stays usable while the dropdown is open; a press anywhere else closes it
      doc.addEventListener("pointerdown", function (e) {
        if (!S.root.classList.contains("is-drop") || !S.root.classList.contains("is-open")) return;
        if (S.hForm.contains(e.target) || $(".dd-search__box", S.root).contains(e.target)) return;
        closeSearch();
      });
      window.addEventListener("scroll", function () { if (S.root.classList.contains("is-drop")) placeDrop(); }, { passive: true });
    }
    doc.addEventListener("keydown", function (e) {
      var typing = /input|textarea|select/i.test((e.target.tagName || "")) || e.target.isContentEditable;
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") { e.preventDefault(); openSearch(); }
      else if (e.key === "/" && !typing) { e.preventDefault(); openSearch(); }
    });
  }

  /* ---------- cart ---------- */
  var C = {};
  function setCount(n, bump) {
    $$("[data-dd-cart-count]").forEach(function (b) {
      b.textContent = n; b.classList.toggle("is-on", n > 0);
      if (bump) { b.classList.remove("is-bump"); void b.offsetWidth; b.classList.add("is-bump"); }
    });
  }
  function typeOf(pt) { pt = (pt || "").toLowerCase(); return pt.indexOf("clip") > -1 ? "Clipart" : pt.indexOf("fussy") > -1 ? "Fussy-Cut Pages" : "Digital Papers"; }
  function renderCart(cart) {
    setCount(cart.item_count);
    var ex = $("[data-dd-cart-express]"); if (ex) ex.hidden = !cart.item_count;
    if (!C.body) return;
    if (!cart.items || !cart.items.length) {
      var tpl = doc.getElementById("dd-cart-empty");
      C.body.innerHTML = tpl ? tpl.innerHTML : "<p style='padding:24px'>Your cart is empty.</p>";
      C.foot.innerHTML = "";
      return;
    }
    C.body.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=200" : "";
      return '<div class="dd-cartline" style="animation-delay:' + (i * 40) + 'ms"><a href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="">' : "") + "</a>" +
        '<div><a href="' + esc(it.url) + '" class="dd-cartline__t" style="text-decoration:none;color:inherit">' + esc(clean(it.product_title)) + '</a><div class="dd-cartline__m">' + typeOf(it.product_type) + " · instant download</div></div>" +
        '<div class="dd-cartline__r"><div class="dd-cartline__p">' + money(it.final_line_price) + '</div><button class="dd-cartline__rm" type="button" data-dd-rm="' + esc(it.key) + '">Remove</button></div></div>';
    }).join("");
    C.foot.innerHTML = '<div class="dd-cart__foot"><div class="dd-cart__total"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<a class="dd-btn dd-btn--block" href="/checkout">Checkout ' + icon("arrow") + '</a><p class="dd-cart__note">Instant download. By checking out you agree your files are available straight away and you lose the 14-day right to cancel once you download. <a href="/policies/refund-policy">Refund policy</a></p></div>';
  }
  function fetchCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function openCart() { openDrawer("cart"); return fetchCart().then(renderCart); }
  function addToCart(id, btn) {
    if (btn) btn.setAttribute("aria-busy", "true");
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) {
        return r.text().then(function (txt) {
          var j = null; try { j = JSON.parse(txt); } catch (e) {}
          if (!r.ok || !j) throw new Error((j && j.description) || "Couldn't add that just now, please try again");
          return j;
        });
      })
      .then(function () {
        if (btn) { btn.removeAttribute("aria-busy"); btn.classList.add("is-done"); btn.innerHTML = icon("check"); }
        return fetchCart().then(function (cart) { setCount(cart.item_count, true); renderCart(cart); openDrawer("cart"); });
      })
      .catch(function (e) { if (btn) btn.removeAttribute("aria-busy"); toast(e.message || "Couldn't add that just now, please try again", true); });
  }
  function initCart() {
    C.body = $("[data-dd-cart-body]"); C.foot = $("[data-dd-cart-foot]");
    doc.addEventListener("click", function (e) {
      var rm = e.target.closest("[data-dd-rm]");
      if (rm) {
        e.preventDefault();
        var line = rm.closest(".dd-cartline"); if (line) line.style.opacity = ".4";
        fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: rm.getAttribute("data-dd-rm"), quantity: 0 }) })
          .then(function (r) { return r.json(); }).then(renderCart);
      }
    });
  }

  /* ---------- global click wiring ---------- */
  function popup(url) {
    var w = 640, h = 720, l = (screen.width - w) / 2, t = (screen.height - h) / 2;
    var win = window.open(url, "dd-share", "width=" + w + ",height=" + h + ",left=" + l + ",top=" + t + ",noopener");
    if (!win) location.href = url;
  }
  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    var ta = doc.createElement("textarea"); ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0"; doc.body.appendChild(ta); ta.select();
    try { doc.execCommand("copy"); } catch (e) {} ta.remove(); return Promise.resolve();
  }
  function initClicks() {
    doc.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-dd-open]");
      if (opener) {
        var what = opener.getAttribute("data-dd-open");
        e.preventDefault();
        if (what === "search") openSearch();
        else if (what === "cart") openCart();
        else openDrawer(what);
        return;
      }
      var closer = e.target.closest("[data-dd-close]");
      if (closer) { var d = closer.closest("[data-dd-drawer]"); if (d) closeDrawer(d); else closeSearch(); return; }
      var add = e.target.closest("[data-dd-add]");
      if (add) { e.preventDefault(); e.stopPropagation(); addToCart(add.getAttribute("data-dd-add"), add); return; }
      var pin = e.target.closest("[data-dd-pin], [data-dd-popup]");
      if (pin) { e.preventDefault(); e.stopPropagation(); popup(pin.href); return; }
      var cp = e.target.closest("[data-dd-copy]");
      if (cp) { e.preventDefault(); copy(cp.getAttribute("data-dd-copy") || location.href).then(function () { toast("Link copied, ready to share"); }); return; }
      var ns = e.target.closest("[data-dd-native-share]");
      if (ns) {
        e.preventDefault();
        var data = { title: ns.getAttribute("data-title") || doc.title, text: ns.getAttribute("data-text") || "", url: ns.getAttribute("data-url") || location.href };
        if (navigator.share) navigator.share(data).catch(function () {});
        else copy(data.url).then(function () { toast("Link copied, ready to share"); });
      }
    });
    doc.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      closeSearch(); closeMegas();
      $$("[data-dd-drawer].is-open").forEach(closeDrawer);
    });
  }

  /* ---------- rails: buttons + drag ---------- */
  function initRails(root) {
    $$("[data-dd-rail]", root).forEach(function (rail) {
      if (rail._dd) return; rail._dd = 1;
      var track = $("[data-dd-rail-track]", rail);
      var sec = rail.closest("section") || rail.parentNode;
      var prev = $("[data-dd-rail-prev]", sec), next = $("[data-dd-rail-next]", sec);
      var step = function () { return track.clientWidth * 0.8; };
      var sync = function () {
        if (prev) prev.disabled = track.scrollLeft < 8;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      };
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: reduce ? "auto" : "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: reduce ? "auto" : "smooth" }); });
      track.addEventListener("scroll", sync, { passive: true }); sync();
      if (!finePointer) return;
      var down = false, sx = 0, sl = 0, moved = 0;
      track.addEventListener("pointerdown", function (e) { if (e.pointerType !== "mouse" || e.button) return; down = true; moved = 0; sx = e.clientX; sl = track.scrollLeft; });
      window.addEventListener("pointermove", function (e) {
        if (!down) return; var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
        if (moved > 6) { track.classList.add("is-dragging"); track.scrollLeft = sl - dx; }
      });
      window.addEventListener("pointerup", function () { if (!down) return; down = false; setTimeout(function () { track.classList.remove("is-dragging"); }, 0); });
      track.addEventListener("click", function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- card tilt ---------- */
  function initTilt() {
    if (!finePointer || reduce) return;
    doc.addEventListener("pointermove", function (e) {
      var m = e.target.closest && e.target.closest("[data-dd-tilt]"); if (!m) return;
      var r = m.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      m.style.transform = "rotateY(" + (x * 7).toFixed(2) + "deg) rotateX(" + (-y * 7).toFixed(2) + "deg) translateY(-4px)";
    }, { passive: true });
    doc.addEventListener("pointerout", function (e) {
      var m = e.target.closest && e.target.closest("[data-dd-tilt]");
      if (m && !m.contains(e.relatedTarget)) m.style.transform = "";
    });
  }

  /* ---------- scroll reveals ---------- */
  function initReveal(root) {
    var els = $$("[data-reveal]:not(.is-in)", root); if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) { els.forEach(function (el) { el.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- heading word reveal: drop the mask once each word has landed,
     so italic overhangs and descenders are never clipped ---------- */
  doc.addEventListener("animationend", function (e) {
    if (e.animationName === "dd-rise" && e.target.parentNode && e.target.parentNode.classList) e.target.parentNode.classList.add("is-done");
  });
  setTimeout(function () { $$(".dd-word").forEach(function (w) { w.classList.add("is-done"); }); }, 4000);

  /* ---------- boot ---------- */
  html.classList.add("dd-reveal-ready");
  function boot() {
    initHeader(); initMegas(); initSearch(); initCart(); initClicks(); initRails(); initTilt(); initReveal();
  }
  window.DD = { toast: toast, money: money, addToCart: addToCart, openCart: openCart, openSearch: openSearch, initRails: initRails, initReveal: initReveal, clean: clean, icon: icon };
  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", boot); else boot();
})();
